import React, { ComponentType, FC } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import {
  IVendorAutocompleteProps,
  VendorAutocomplete,
} from '../VendorAutocomplete/VendorAutocomplete'

export type IBaseControllerProps = ControllerProps<ComponentType<IVendorAutocompleteProps>>

export interface IControlledVendorAutocompleteProps
  extends Pick<IBaseControllerProps, 'control' | 'name'> {
  defaultValue?: string
  VendorAutocompleteProps?: Omit<
    IVendorAutocompleteProps,
    'name' | 'control' | 'ref' | 'value' | 'onBlur' | 'onChange'
  >
  onChange?: (vendorId: string | null) => void
}

export const ControlledVendorAutocomplete: FC<IControlledVendorAutocompleteProps> = ({
  VendorAutocompleteProps,
  control,
  defaultValue,
  name,
  onChange: onChangeProp,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ onChange, value, ...props }) => {
        const changeHandler: IVendorAutocompleteProps['onChange'] = (newVal, vendorId) => {
          if (newVal) {
            onChange(newVal)
          } else {
            onChange(null)
          }
          if (onChangeProp) onChangeProp(vendorId)
        }

        return (
          <VendorAutocomplete
            onChange={changeHandler}
            value={value}
            {...VendorAutocompleteProps}
            {...props}
          />
        )
      }}
    />
  )
}

export default ControlledVendorAutocomplete
